import PropTypes from 'prop-types';
import React from 'react';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Box } from '@eatclubapp/ec-component-library';
import { useSelector } from 'react-redux';
import { trackDetailedEvent } from '../../../utils/analytics';
import { PrimaryButton } from '../../button/PrimaryButton';
import { Modal } from '../../Modal';

const DoubleChargeRefundModal = ({ isOpen, onClose, onConfirm }) => {
  const theme = useTheme();
  const breakpointSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const restId = useSelector((state) => state.restaurantActive.restaurant?.objectId);

  // Block backdrop / escape dismiss; X still closes via button click (no reason arg)
  const handleClose = (_event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return;
    }
    onClose();
  };

  const handleConfirm = () => {
    trackDetailedEvent('button_click: confirm_double_charge_refund', {
      restId,
      timestamp: new Date().toISOString(),
      acknowledgement: true,
    });
    onConfirm();
  };

  return (
    <Modal
      heading=''
      isOpen={isOpen}
      onClose={handleClose}
      hideFooter
      inputProps={{
        disableEscapeKeyDown: true,
      }}
      style={{
        content: {
          padding: breakpointSmDown ? '24px' : '48px',
        },
        heading: {
          display: 'none',
          marginBottom: 0,
        },
      }}
    >
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '32px',
          alignItems: 'flex-start',
        }}
      >
        <Box
          style={{
            fontSize: breakpointSmDown ? '28px' : '36px',
            lineHeight: breakpointSmDown ? '32px' : '36px',
            color: '#1A1919',
            fontWeight: 500,
          }}
        >
          Resolving duplicate settlement charges
        </Box>

        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            fontSize: '18px',
            lineHeight: '24px',
            color: '#6E6E6D',
            width: '100%',
          }}
        >
          <Box>
            We&apos;ve identified an error that caused venues to be charged twice for last
            week&apos;s settlement (Mon 13 Jul – Sun 19 Jul 2026). This was our mistake and
            we&apos;re sincerely sorry.
          </Box>
          <Box>
            We&apos;ve already fixed the bug so it can&apos;t affect any future settlements.
          </Box>
          <Box>
            Refunds for the duplicate charge are being processed today and will be returned
            automatically to your settlement account. No action is needed on your side. Funds may
            take a few business days to appear depending on your bank.
          </Box>
          <Box>
            If anything about your refund looks wrong, please contact your Account Manager or our
            support team and we&apos;ll prioritise it.
          </Box>
        </Box>

        <PrimaryButton
          onClick={handleConfirm}
          fullWidth={breakpointSmDown}
          style={{
            button: {
              backgroundColor: '#FAD14C',
              color: '#313131',
              height: '40px',
              minWidth: 'auto',
              padding: '10px 24px',
              borderRadius: '100px',
              border: 'none',
              fontWeight: 400,
              fontSize: '16px',
            },
          }}
        >
          Got it
        </PrimaryButton>
      </Box>
    </Modal>
  );
};

DoubleChargeRefundModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default DoubleChargeRefundModal;
